const pushBus = new EventTarget();
const FOREGROUND_BUS_TYPE = 'foreground';
const RECENT_PUSH_TTL_MS = 5000;
const MAX_RECENT_PUSH_KEYS = 500;

/** @type {Map<string, number>} */
const recentPushKeys = new Map();

const buildPushDedupKey = (detail = {}) => {
  const data = detail?.data && typeof detail.data === 'object' ? detail.data : detail;

  const explicitKey =
    detail?.notificationId ||
    detail?.notification_id ||
    data?.notificationId ||
    data?.notification_id ||
    detail?.messageId ||
    data?.messageId ||
    detail?.tag;

  if (explicitKey) {
    return String(explicitKey);
  }

  const title = detail?.title || '';
  const body = detail?.body || detail?.message || '';
  const type = data?.type || detail?.type || '';
  const eventType = data?.eventType || data?.notificationType || detail?.eventType || '';

  if (title || body) {
    return `content:${type}:${eventType}:${title}:${body}`;
  }

  return '';
};

const pruneRecentPushKeys = (now) => {
  for (const [key, seenAt] of recentPushKeys.entries()) {
    if (now - seenAt > RECENT_PUSH_TTL_MS) {
      recentPushKeys.delete(key);
    }
  }

  if (recentPushKeys.size <= MAX_RECENT_PUSH_KEYS) {
    return;
  }

  const overflow = recentPushKeys.size - MAX_RECENT_PUSH_KEYS;
  const oldestKeys = [...recentPushKeys.entries()]
    .sort((left, right) => left[1] - right[1])
    .slice(0, overflow)
    .map(([key]) => key);

  for (const key of oldestKeys) {
    recentPushKeys.delete(key);
  }
};

const shouldDispatchForegroundPush = (detail = {}) => {
  const key = buildPushDedupKey(detail);
  if (!key) {
    return true;
  }

  const now = Date.now();
  const lastSeenAt = recentPushKeys.get(key);
  if (lastSeenAt != null && now - lastSeenAt < RECENT_PUSH_TTL_MS) {
    return false;
  }

  recentPushKeys.set(key, now);
  pruneRecentPushKeys(now);
  return true;
};

export const dispatchForegroundPushEvent = (detail) => {
  if (!shouldDispatchForegroundPush(detail)) {
    return;
  }

  try {
    pushBus.dispatchEvent(new CustomEvent(FOREGROUND_BUS_TYPE, { detail }));
  } catch (_) {
    // Ignore dispatch failures in unsupported/restricted environments.
  }
};

/** @param {(event: Event) => void} handler @returns {() => void} */
export const subscribeForegroundPush = (handler) => {
  pushBus.addEventListener(FOREGROUND_BUS_TYPE, handler);
  return () => pushBus.removeEventListener(FOREGROUND_BUS_TYPE, handler);
};
